module.exports = __webpack_public_path__ + "img/272.7a90260b.png";